import React, { useState } from 'react'
import CreateAccount from '../Components/CreateAccount';
import PersonalInfo from '../Components/PersonalInfo';
import '../Styles/RegistrationPortal.scss'
import { useNavigate } from "react-router-dom"
import CreateMedicalInsuranceInformation from '../Components/MedicalInsuranceInformation';
import Session from 'react-session-api';
import {Helmet} from "react-helmet";


function CreateIndividualAccount ()
{

// const [fakeDataAlert, setFakeDataAlert] = useState(false); 
const [fakeDataSubmission, setFakeDataSubmission] = useState(false); 

const [error, setError]     = useState(false)

const navigate = useNavigate()
/*                            Handle Account Information                            */ 

const [accountInformation, setAccountInformation] = useState({
   email: '',
   password: '',
   confirmPassword: '',
   firstName: '',
   lastName: '',
   gender: '',
   birthDate: null,
   addressLineOne: '',
   addressLineTwo: '',
   city: '',
   state: '',
   zip: '',
   country: '',
   phone: '',
   accountType: ''
})

   const handleSubmit = async () => {
      try {
            const apiResponse = await fetch('/api/register', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               email: accountInformation.email,
               password: accountInformation.password,
               firstName: accountInformation.firstName,
               lastName: accountInformation.lastName,
               birthDate: accountInformation.birthDate,
               gender: accountInformation.gender,
               addressLineOne: accountInformation.addressLineOne,
               addressLineTwo: accountInformation.addressLineTwo,
               city: accountInformation.city,
               state: accountInformation.state,
               zip: accountInformation.zip,
               country: accountInformation.country,
               phone: accountInformation.phone,
               accountType: "Individual"
           })
         })

         const registerResult = await apiResponse.json();
         console.log("registrationResult", registerResult)
        

         if (apiResponse.status === 400 || apiResponse.status === 500) {
            throw new Error(registerResult.errors[0].msg);
         }

         // Logs into the account
         const apiResponse2 = await fetch('/api/login', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               email: accountInformation.email,
               password: accountInformation.password
           })
         })

         const loginResult = await apiResponse2.json();

         if (apiResponse2.status === 400 || apiResponse2.status === 500) {
            throw new Error(loginResult.errors[0].msg);
         }

         Session.set("isAuth", apiResponse2.ok.toString())
         Session.set("accountType", "individual")

         navigate('/individualAccount');
      }
      catch (error) {
         setError(error.message);
      }
   }

return (
  <div className="IndividualSignUp">
       <div className="page0Container">
         <CreateAccount 
         accountInformation={accountInformation} 
         setAccountInformation={setAccountInformation} 
         handleSubmit={handleSubmit}/>
       </div>
  </div>
) 
}
export default CreateIndividualAccount; 